module.exports = __webpack_public_path__ + "static/04-fb89051b4628542c7a73ae4f5efc3a12.jpg";